import { darken, styled } from "@mui/material/styles";

// Components
import { IconButton } from "@mui/material";
import { theme } from "~/components/Common";

const styledName = "TransactionInfo";

export const StyledDeleteButton = styled(IconButton, { name: styledName })({
  "&": {
    height: "40px",
    width: "40px",

    fill: theme.palette.error.light,
    fontSize: "2.4rem",

    ":hover": {
      cursor: "pointer",
      fill: darken(theme.palette.error.light, 0.1),
    },
    ":active": {
      animation: `shaking 0.2s linear infinite`,
    },
  },
});
